<template>
  <div>
    <ca-heading :text="titleMixin" />

    <ca-page>
      <ca-form
        :key="formKey"
        :on-submit="onSubmit">
        <worker-job-info-form
          :job-info="workInfo"
          @refresh-form="refreshForm"></worker-job-info-form>
        <worker-form-footer :on-back="goBack"></worker-form-footer>
      </ca-form>
    </ca-page>
  </div>
</template>

<script>
import { initFormObject } from 'packages/common/utils';
import WorkerJobInfoForm from './WorkerJobInfoForm';
import WorkerFormFooter from '../WorkerFormFooter';
import {
  hasWorkerDraft,
  setWorkerDraft,
  getWorkerDraft,
} from '../../workersService';
import { hasWorkInfoDraft } from './workerInfoJobService';
import { workerFormMixin } from '../../mixins/WorkerFormMixin';
import { clickToGoWorkerContractInfoFormPage } from '../../workerTrackerService';

export default {
  name: 'WorkerJobInfoFormPage',
  components: {
    WorkerJobInfoForm,
    WorkerFormFooter,
  },
  mixins: [workerFormMixin],
  props: {
    previousStep: Function,
    nextStep: Function,
  },
  data() {
    return {
      formKey: 0,
      showLoading: false,
      workInfo: {
        ...initFormObject([
          { workingType: 'C' },
          { workingHoursType: 'S' },
          { pensionType: 'G' },
          { natureActivityWork: 'U' },
          { agentExposureType: 'N' },
          { category: 'O101' },
          { anotherCompanyInformation: 'S' },
        ]),
        baseDate: null,
      },
    };
  },
  computed: {
    workerBasicInfo() {
      return getWorkerDraft();
    },
    misc() {
      return this.$store.state.misc;
    },
  },
  created() {
    if (!hasWorkerDraft()) {
      this.$emit('on-reset-steps');
    } else {
      this.initData();
    }
  },
  methods: {
    initData() {
      const { basicInfo: { name } } = this.workerBasicInfo;
      this.$store.dispatch('breadcrumb/setBreadcrumbProps', { workerName: name });

      if (hasWorkInfoDraft()) {
        this.setInfoJob();
      } else {
        this.workInfo.baseDate = this.workerBasicInfo?.basicInfo?.union?.categoryBaseDateDay
          || null;
      }
    },
    setInfoJob() {
      const baseDate = this.workerBasicInfo.basicInfo?.union?.categoryBaseDateDay || null;
      this.workInfo = hasWorkInfoDraft()
        ? this.workerBasicInfo.workInfo
        : { ...this.workInfo, baseDate };
    },
    goBack() {
      this.previousStep();
    },
    onSubmit() {
      clickToGoWorkerContractInfoFormPage();
      setWorkerDraft({ workInfo: this.workInfo });
      return this.nextStep();
    },
    refreshForm() {
      this.formKey++;
    },
  },
};
</script>
